import React from 'react';
import { AnchorLink } from './AnchorLink';

/**
 * Card component.
 * @param param0 
 * @returns 
 */
export const Card: React.FunctionComponent<{
    onClick?: () => void;
    className?: string;
    href?: string;
}> = function ({ children, href, onClick, className }) {

    const onCardClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const renderCard = () => {
        if (href) {
            return (
                <AnchorLink href={href}>
                    <div className={'card ' + className} onClick={onCardClick}>
                        {children}
                    </div>
                </AnchorLink>
            )
        } else {
            return (
                <div className={'card ' + className} onClick={onCardClick}>
                    {children}
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {renderCard()}
        </React.Fragment>
    );
}

/**
 * Card Header.
 * @param param0 
 * @returns 
 */
export const CardHeader: React.FunctionComponent<{
    onClick?: () => void;
    className?: string;
    href?: string;
}> = function ({ children, href, onClick, className }) {

    const onHeaderClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const renderCard = () => {
        if (href) {
            return (
                <AnchorLink href={href}>
                    <div className={"card-header bg-primary text-light " + className} onClick={onHeaderClick}>
                        {children}
                    </div>
                </AnchorLink>
            )
        } else {
            return (
                <div className={"card-header bg-primary text-light " + className} onClick={onHeaderClick}>
                    {children}
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {renderCard()}
        </React.Fragment>
    );
}

/**
 * Card Body.
 * @param param0 
 * @returns 
 */
 export const CardBody: React.FunctionComponent<{
    onClick?: () => void;
    className?: string;
    href?: string;
}> = function ({ children, href, onClick, className }) {

    const onHeaderClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const renderCard = () => {
        if (href) {
            return (
                <AnchorLink href={href}>
                    <div className={"card-body " + className} onClick={onHeaderClick}>
                        {children}
                    </div>
                </AnchorLink>
            )
        } else {
            return (
                <div className={"card-body " + className} onClick={onHeaderClick}>
                    {children}
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {renderCard()}
        </React.Fragment>
    );
}

/**
 * Card Footer.
 * @param param0 
 * @returns 
 */
 export const CardFooter: React.FunctionComponent<{
    onClick?: () => void;
    className?: string;
    href?: string;
}> = function ({ children, href, onClick, className }) {

    const onHeaderClick = () => {
        if (onClick) {
            onClick();
        }
    };

    const renderCard = () => {
        if (href) {
            return (
                <AnchorLink href={href} className="mt-auto">
                    <div className={"card-footer bg-primary text-light " + className} onClick={onHeaderClick}>
                        {children}
                    </div>
                </AnchorLink>
            )
        } else {
            return (
                <div className={"card-footer bg-primary text-light " + className} onClick={onHeaderClick}>
                    {children}
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {renderCard()}
        </React.Fragment>
    );
}